<template>
  <div v-if="orderInfo.goodsList?.length" class="order-item">
    <div>
      <img
        v-if="orderInfo.goodsList[0].goodsType === '5'"
        class="img"
        src="@/assets/img/mobile-img/paper-default.png"
      />
      <img
        v-else
        class="img"
        :src="
          orderInfo.goodsList[0].albumPics
            ? $global.imgUrl + orderInfo.goodsList[0].albumPics.split(',')[0]
            : require('@/assets/img/mobile-img/zz_default.png')
        "
      />
    </div>
    <div class="business-information-right">
      <div class="title">
        <span
          class="line-clamp-1"
          v-html="orderInfo.goodsList[0].goodsName"
        ></span>
      </div>
      <div class="number">
        <span>
          {{ orderInfo.goodsList[0].specificationsValueOne }}
          {{ orderInfo.goodsList[0].specificationsValueTwo }}
        </span>
        <span>x{{ orderInfo.goodsList[0].saleNum }}</span>
      </div>
      <div class="price">¥{{ orderInfo.payAmount }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
.order-item {
  display: flex;
  .img {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    object-fit: cover;
    border-radius: 4px;
  }
  .business-information-right {
    flex: 1;
    .title {
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      line-height: 23px;
      margin-bottom: 10px;
    }
    .price {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
      margin-bottom: 10px;
    }
    .number {
      font-size: 13px;
      color: #999999;
      line-height: 18px;
      margin-bottom: 10px;
    }
  }
}
</style>